/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react';
import StyledButtonBase from 'views/rebranded-module/common/components/UI/DealCardV2/DealCardV2.styles';
import { Box, Typography, Button } from '@mui/material';
import { ImgBox, Typography700 } from 'views/rebranded-module/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import Typography500 from 'views/common/components/UI/Typography500';
import { RiArrowRightUpLine } from 'react-icons/ri';
import { useContent } from 'views/rebranded-module/common/context/useContent';

// Define image type
interface ImageObject {
  src: string;
  alt: string;
}

// Define link type
interface LinkObject {
  pathname?: string;
  href?: string;
  to?: string;
  [key: string]: any;
}

// Define the props interface
interface DealCardV2Props {
  image: string | ImageObject;
  title: string;
  link: string | LinkObject; // Accept both string and object
  dealValue: string;
  tagline?: string;
  oldValue?: string;
  description?: string;
  isLargeImage?: boolean;
  showBtn?: boolean;
}

const DealCardV2: FC<DealCardV2Props> = ({
  image,
  title,
  link,
  tagline,
  oldValue,
  dealValue,
  description,
  isLargeImage = false,
  showBtn = false,
}) => {
  const content = useContent('DealCardComponent');

  return (
    <StyledButtonBase component={NavigatorLink} href={link} sx={{ width: '100%' }}>
      <Box className={`DCImgContainer ${isLargeImage ? 'DCLargeImage' : ''}`}>
        <ImgBox
          image={{ src: image, alt: title }}
          width="100%"
          height="100%"
          objectFit="cover"
          unoptimized
        />
      </Box>
      {(dealValue || oldValue) && (
      <Box className="DCValueContainer">
        <Typography700
          className="DCValue"
          component="span"
          dangerouslySetInnerHTML={{ __html: dealValue }}
        />
        {oldValue && (
        <Typography500
          component="span"
          className="DCOldValue"
          dangerouslySetInnerHTML={{ __html: oldValue }}
          />
        )}
      </Box>
      )}

      <Box className="DCVInfo">
        {tagline && (
          <Typography700
            className="DCTageLine"
            variant="overline2"
            component="p"
            mb={1.5}
          >
            {tagline}
          </Typography700>
        )}
        <Typography700 className="DCMaxText" variant="h6" component="p">
          {title}
        </Typography700>
        {description && (
          <Typography
            mt={3}
            mb={2}
            className="CDescriptions DCMaxText"
            component="p"
            variant="body1"
            color="text.secondary"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {showBtn && (
          <Button
            variant="text"
            color="secondary"
            className="DCBtn"
            endIcon={<RiArrowRightUpLine />}
          >
            {content.learnMoreBtnLabel}
          </Button>
        )}
      </Box>
    </StyledButtonBase>
  );
};

export { DealCardV2 };
